import ExamMasterList from "../components/ExamMasterList";

export default function MasterObat() {
    return (
        <ExamMasterList
            kind="obat"
            title="Master Obat & BMHP"
            subtitle="Kelola daftar obat dan bahan medis habis pakai beserta harga jual."
            testidPrefix="obat"
            hasUnitCost={false}
            showJasaMedis={false}
        />
    );
}
